import React from 'react';
import PropTypes from 'prop-types';
import { TrackClickAfterSearch } from '@rsc/utils/algoliaAnalytics';
import { Text, Grid, GridItem, Box, Image } from '@chakra-ui/react';
import Link from '@rsc/ui-components/tailwind/Link';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

function SearchFormHit({ hit, insights }) {
  const { title, excerpt, image, link, variants } = hit;
  const href = !link.startsWith('/') ? `/${link}` : link;

  const { localizePrice } = useUiComponentsInternationalContext();

  const isProduct = variants?.length > 0;
  return (
    <Box
      py="2"
      borderBottom="1px solid #bcbcbc"
      w={{ base: 'full', lg: '400px' }}
    >
      <Grid
        templateColumns="repeat(3, 1fr)"
        gap={4}
        as={Link}
        link={href}
        onClick={() => {
          TrackClickAfterSearch(insights);
        }}
        state={{ searchedProduct: hit?.__queryID || null }}
        aria-label={title}
      >
        {image && (
          <GridItem
            colSpan={1}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Image
              src={`${image}${isProduct ? '&width=64&height=64' : ''}`}
              alt={title}
              w="16"
              h="16"
              mr="4"
            />
          </GridItem>
        )}
        <GridItem colSpan={image ? 2 : 3}>
          <Text textStyle="h4_5_6" as="h3" color="typography.light">
            {title}
          </Text>
          {isProduct ? (
            <Text textStyle="bodyLarge" as="h4" bold>
              {localizePrice(variants[0].price)}
            </Text>
          ) : (
            <Text
              textStyle="body"
              noOfLines={4}
              dangerouslySetInnerHTML={{ __html: excerpt }}
            />
          )}
        </GridItem>
      </Grid>
    </Box>
  );
}

SearchFormHit.propTypes = {
  hit: PropTypes.shape({
    title: PropTypes.string.isRequired,
    excerpt: PropTypes.string,
    image: PropTypes.string.isRequired,
    slug: PropTypes.string,
    link: PropTypes.string,
    variants: PropTypes.arrayOf(
      PropTypes.shape({
        price: PropTypes.number,
        compareAtPrice: PropTypes.string,
      })
    ),
    __queryID: PropTypes.string,
  }),
  insights: PropTypes.func.isRequired,
};

SearchFormHit.defaultProps = {
  hit: {
    excerpt: '',
    variants: [],
    slug: '',
    link: '',
  },
};

export default SearchFormHit;
